import comingSoonGif from "@assets/gifs/coming-soon.gif";
import { routes } from "@constants/routes";
import { ComingSoon } from "@cpj-ai/panel-npm-package";
import { Button } from "@heroui/react";
import { useNavigate } from "react-router-dom";

const FinancialComingSoon = () => {
  const navigate = useNavigate();
  const handleGoToSupport = () => {
    navigate(routes.support.main);
  };

  return (
    <ComingSoon
      gif={comingSoonGif}
      title="Financial"
      subTitle="Coming Soon... "
      bottomContent={
        <div className="mt-8">
          <Button color="primary" onPress={handleGoToSupport}>
            Contact Support Team
          </Button>
        </div>
      }
      description="We are excited to share our plans for enhancing your experience! While we're currently developing an automated financial management feature for the future, you can already handle all your financial needs through our Support section. Soon, you'll enjoy a streamlined, automated process, but for now, our dedicated support team is ready to assist you with any financial matters. We're working hard to bring you these automated tools that will make managing your finances even more convenient and efficient. Stay tuned for these upcoming improvements!"
    />
  );
};

export default FinancialComingSoon;
